module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "invoiceRecordMod"
  }, [_c('div', {
    staticClass: "page clear page1"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "val",
    staticStyle: {
      "color": "#333",
      "font-size": "1.1rem"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.timeFn) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "status",
    class: _vm.stateFn === '待开' ? 'statusShow' : ''
  }, [_vm._v("\n      " + _vm._s(_vm.stateFn) + "\n      "), _c('span', {
    staticClass: "iconfont icon-jiantou"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "page clear page2"
  }, [_c('div', {
    staticClass: "title"
  }), _vm._v(" "), _c('div', {
    staticClass: "val",
    staticStyle: {
      "font-size": "1.2rem"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.type) + "\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "page clear page3"
  }, [_c('div', {
    staticClass: "title"
  }), _vm._v(" "), _c('div', {
    staticClass: "val",
    staticStyle: {
      "font-size": "1.2rem"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.memo) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "sum"
  }, [_vm._v("\n      " + _vm._s(_vm.sum)), _c('span', {
    staticStyle: {
      "font-size": "1rem",
      "margin-left": ".2rem"
    }
  }, [_vm._v("元")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('i', {
    staticClass: "iconfont icon-shijian1"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-39018182","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/module/invoiceRecordMod/src/invoiceRecordMod.vue
// module id = 524
// module chunks = 0